import { normalizeRefineParameter } from "../../../../helpers/normalizeRefineParameter";
import {
  getSelectedRange,
  rangeSelection,
  valuesSelection,
  VALUES,
} from "../model/selection";

export const PRICE_FACET_ID = "currentprice";

const REFINEMENT_SEPARATOR = "|";
const VALUE_SEPARATOR = ",";
const ID_VALUES_SEPARATOR = ":";
const PRICE_SEPARATOR = "<";
const BOUNDS_RANGE_SEPARATOR = "-";

const toArray = (value) =>
  Array.isArray(value) ? value : [value].filter(Boolean);

const toRefinements = (refine) =>
  toArray(refine)
    .join(REFINEMENT_SEPARATOR)
    .split(REFINEMENT_SEPARATOR)
    .filter(Boolean);

const toRange = (value, separator) => {
  if (typeof value !== "string") {
    return;
  }

  const parts = value.split(separator);

  if (parts.length !== 2 || parts.some((part) => part.trim() === "")) {
    return;
  }

  const [min, max] = parts.map(Number);

  return Number.isFinite(min) && Number.isFinite(max)
    ? { min, max }
    : undefined;
};

// Price selection belongs in `refine`; its original slider bounds stay in
// `currentpricerange` because a filtered API response reports narrower bounds.
export const decode = (query = {}) => {
  const selection = { facets: {} };
  const bounds = toRange(query.currentpricerange, BOUNDS_RANGE_SEPARATOR);

  toRefinements(query.refine).forEach((refinement) => {
    const [facetId, rawValues] = refinement.split(ID_VALUES_SEPARATOR);

    if (!facetId || !rawValues) {
      return;
    }

    if (facetId === PRICE_FACET_ID) {
      const price = toRange(rawValues, PRICE_SEPARATOR);

      if (price) {
        selection.facets[PRICE_FACET_ID] = rangeSelection(price);
      }

      return;
    }

    selection.facets[facetId] = valuesSelection(
      rawValues.split(VALUE_SEPARATOR).filter(Boolean),
    );
  });

  if (query.sort) {
    selection.sort = query.sort;
  }

  return { selection, bounds };
};

const encodeRefine = (selection) => {
  const price = getSelectedRange(selection, PRICE_FACET_ID);

  const refine = Object.entries(selection.facets || {})
    .filter(
      ([, facetSelection]) =>
        facetSelection?.kind === VALUES && facetSelection.values.length > 0,
    )
    .map(
      ([facetId, { values }]) =>
        `${facetId}${ID_VALUES_SEPARATOR}${values.join(VALUE_SEPARATOR)}`,
    )
    .concat(
      price
        ? `${PRICE_FACET_ID}${ID_VALUES_SEPARATOR}${price.min}${PRICE_SEPARATOR}${price.max}`
        : [],
    )
    .join(REFINEMENT_SEPARATOR);

  return refine ? normalizeRefineParameter({ refine }) : undefined;
};

const encodeBounds = (bounds) =>
  bounds ? `${bounds.min}${BOUNDS_RANGE_SEPARATOR}${bounds.max}` : undefined;

export const encode = (selection = {}, bounds) => ({
  refine: encodeRefine(selection),
  currentpricerange: encodeBounds(bounds),
  sort: selection.sort,
});
